export enum Approval_Status {
    PENDING = 0,
    APPROVED = 1,
    REJECTED = 2,
    CANCEL = 3,
    IMPROVEMENT_REQUESTED = 4,
    IN_REVIEW = 5,
    COMPLETED = 6,
    CLOSED = 7
};
